import { useEffect, useState } from 'react';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { InputAdornment, OutlinedInput } from '@mui/material';
import type { FilterBarSearchInputProps } from './contracts';

const FilterBarSearchInput = ({
  id,
  label,
  placeholder = 'Search by…',
  value,
  defaultValue = '',
  onChange,
  onKeyUpCallback,
  onFocusCallback,
  inputRef,
  className,
  width = '300px',
  disabled,
}: FilterBarSearchInputProps) => {
  const [inputValue, setInputValue] = useState(value ?? defaultValue);
  const accessibleLabel = typeof label === 'string' ? label : placeholder;

  useEffect(() => {
    if (value !== undefined) setInputValue(value);
  }, [value]);

  const handleChange = (nextValue: string) => {
    setInputValue(nextValue);
    onChange?.(nextValue);
  };

  return (
    <OutlinedInput
      id={id}
      className={className}
      inputRef={inputRef}
      inputProps={{ 'aria-label': accessibleLabel }}
      size="small"
      value={inputValue}
      placeholder={placeholder}
      disabled={disabled}
      onChange={event => handleChange(event.target.value)}
      onKeyUp={onKeyUpCallback}
      onFocus={onFocusCallback}
      startAdornment={
        <InputAdornment position="start">
          <SearchOutlinedIcon color="primary" />
        </InputAdornment>
      }
      sx={{
        width,
        backgroundColor: 'common.white',
        '& .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main', borderWidth: 1 },
      }}
    />
  );
};

export default FilterBarSearchInput;
